// extracted by mini-css-extract-plugin
module.exports = {"root":"Chat_root__1gGCM","messages":"Chat_messages__ngGkd","dateDivider":"Chat_dateDivider__1aqMG"};